import {
    asyncRequest,
    Currency,
    Entities,
    EntityCollectionState,
    FetchBySearch,
    getEntities,
    search,
    TOMCAT_URL,
} from 'src/common/index';
import Money from 'src/common/entity/basic-types/Money';
import DatePicker from 'material-ui/DatePicker';
import Drawer from 'material-ui/Drawer';
import moment from 'moment';
import React, { Component } from 'react';
import { BootstrapTable, TableHeaderColumn, ToolBarProps } from 'react-bootstrap-table';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { addErrorNotification, addNotification } from 'src/actions/notifications';
import ErrorMessage from 'src/components/misc/error-message';
import { InjectedTranslateProps, StoreState } from 'src/types';
import { priceFormatter, validFormatter } from 'src/utils/formatters';
import { copyToClipboard } from 'src/utils/helpers';
import composeModalActions, { InjectedModalProps } from 'src/utils/modal-action-wrapper';
import TableHelper from 'src/utils/table-helper';
import RaisedButton from 'material-ui/RaisedButton';
import BootstrapTableErrorBoundary from 'src/components/error/BootstrapTableErrorBoundary';
import AutoComplete from 'material-ui/AutoComplete';
import TextField from 'material-ui/TextField';
import Toggle from 'material-ui/Toggle';
import BigNumber from 'bignumber.js';

interface MapStateToProps {
    requests: EntityCollectionState<any>;
}

interface OwnProps {
    integrationId?: number;
}

interface TableDataRow {
    id: number;
    createdAt: string;
    email: string;
    pax: number;
    fromTime: string;
    fromLocation: string;
    toTime: string;
    toLocation: string;
    intermediateCount: number;
    intermediateBreakSumInMinutes?: number;
    distance: number;
    results: number;
    cheapestPrice?: Money;
    bookingToken?: string;
    bookingIntegrationUrl?: string;
    bookingIntegrationCountry?: string;
    entity: any;
}

interface TableData extends Array<TableDataRow> {}

interface State {
    startedFetching: boolean;
    renderSelection?: boolean;
    drawerOpen: boolean;
    selectedRow?: TableDataRow;
    fromDate: Date;
    toDate: Date;
    autoCompleteService: any;
    geoCoder: any;
    geoCodedDataSource: [];
    selectedArea: { lat?: number; lng?: number; address?: string };
    range: number;
    showOnlyBookings: boolean;
    isGoogleMapsLoaded: boolean;
    includeBookingIntegrationAllCompanies: boolean;
    tableData: TableData;
    isLoading: boolean;
}

interface MapDispatchToProps extends FetchBySearch {
    addNotification: (title: string, message: string, level: string, position: string) => void;
    addErrorNotification: (error: any) => void;
}

type Props = MapStateToProps & MapDispatchToProps & InjectedModalProps & InjectedTranslateProps & OwnProps;

class SearchRequestsAdminTable extends Component<Props, State> {
    private tableHelper: any;
    private table: any;

    constructor(props: Props) {
        super(props);

        this.tableHelper = new TableHelper({
            onRowClick: this.onRowClick,
            pageSize: 100,
        });
        this.state = {
            startedFetching: true,
            drawerOpen: false,
            fromDate: moment().startOf('month').toDate(),
            toDate: moment().toDate(),
            isGoogleMapsLoaded: false,
            autoCompleteService: null,
            geoCoder: null,
            geoCodedDataSource: [],
            selectedArea: { lat: undefined, lng: undefined, address: undefined },
            range: 50,
            showOnlyBookings: false,
            includeBookingIntegrationAllCompanies: false,
            tableData: [],
            isLoading: false,
        };
    }

    public componentWillMount() {
        // this.fetchSearchRequests(this.props.integrationId);
    }

    public shouldComponentUpdate(nextProps: Props) {
        return !nextProps.modal.open;
    }

    public componentWillReceiveProps(nextProps: Props) {
        const { requests, integrationId } = nextProps;
        if (!this.state.startedFetching && requests.isFetching) this.setState({ startedFetching: true });
        if (this.props.integrationId && this.props.integrationId !== integrationId)
            this.fetchSearchRequests(integrationId);
        this.tableHelper.processPagination(requests.items.length);
    }

    componentDidMount() {
        this.checkGoogleMapsLoaded();
        this.recalculateTableData(this.props.requests.items, this.state.showOnlyBookings);
    }

    checkGoogleMapsLoaded = () => {
        if (window.google && window.google.maps) {
            this.setState({
                isGoogleMapsLoaded: true,
                autoCompleteService: new window.google.maps.places.AutocompleteService(),
                geoCoder: new window.google.maps.Geocoder(),
            });
        } else {
            setTimeout(this.checkGoogleMapsLoaded, 500);
        }
    };

    public componentDidUpdate(prevProps: Props, prevState: State) {
        if (prevProps.requests.isFetching && !this.props.requests.isFetching) {
            this.setState({ isLoading: false });
        }

        if (
            prevProps.requests.items !== this.props.requests.items ||
            prevState.showOnlyBookings !== this.state.showOnlyBookings
        ) {
            this.recalculateTableData(this.props.requests.items, this.state.showOnlyBookings);
        }
    }

    private recalculateTableData = (requests: any[], showOnlyBookings: boolean) => {
        const tableData: TableData = [];
        if (requests && requests.length > 0) {
            for (const request of requests) {
                if (showOnlyBookings && !request.bookingToken) continue;
                tableData.push({
                    id: request.id,
                    createdAt: moment(request.createdAt).utc().format('DD.MM.YYYY HH:mm:ss'),
                    email: request.contactData != null ? request.contactData.email : null,
                    fromTime: moment(request.arrivalDateTime).format('DD.MM.YYYY HH:mm'),
                    toTime: moment(request.destinationArrival).format('DD.MM.YYYY HH:mm'),
                    fromLocation: request.arrivalAddress,
                    toLocation: request.destinationAddress,
                    pax: request.pax,
                    intermediateCount: request.totalStops - 2,
                    intermediateBreakSumInMinutes: request.breakTimeInMinutes,
                    distance:
                        request.distanceInMeters != null
                            ? request.distanceInMeters
                            : request.distanceInMetersCalculated,
                    cheapestPrice: request.cheapestPrice
                        ? new Money(new BigNumber(request.cheapestPrice), Currency.EUR)
                        : new Money(new BigNumber(0), Currency.EUR),
                    results: request.amountSearchResults,
                    bookingToken: request.bookingToken,
                    bookingIntegrationUrl: request.bookingIntegrationUrl,
                    bookingIntegrationCountry: request.bookingIntegrationCountry,
                    entity: request,
                });
            }
        }
        this.setState({ tableData });
    };

    public render() {
        const { requests, integrationId, t } = this.props;
        const { tableData, isLoading } = this.state;

        const finishFetching = this.state.startedFetching && !requests.isFetching;
        if (requests.error) return <ErrorMessage object={requests} />;

        const requestsCount = tableData.length;
        const requestBookings = tableData.filter(row => row.bookingToken).length;

        const tableOptions = {
            ...this.tableHelper.getOptions(finishFetching),
            toolBar: this.createCustomToolBar,
            noDataText: isLoading ? (
                <span>
                    <i className="fa fa-spinner fa-spin"></i>
                    {t('common_phrases.loading')}
                </span>
            ) : (
                t('no_entries')
            ),
        };

        return (
            <div>
                {this.renderDrawer()}
                {!isLoading && this.renderStats(requestsCount, requestBookings)}
                <div id="searchRequestsTable">
                    <BootstrapTableErrorBoundary>
                        <BootstrapTable
                            ref={ref => (this.table = ref)}
                            data={tableData}
                            striped={true}
                            hover={true}
                            exportCSV={true}
                            condensed={true}
                            pagination={true}
                            options={tableOptions}
                            selectRow={Object.assign({}, this.tableHelper.getRowProps())}
                            searchPlaceholder={t('common_phrases.search')}
                            search={true}>
                            <TableHeaderColumn
                                columnTitle={true}
                                dataField="id"
                                hidden={true}
                                isKey={true}
                                export={true}>
                                ID
                            </TableHeaderColumn>
                            <TableHeaderColumn columnTitle={true} width="140" dataField="createdAt" dataSort={true}>
                                {t('search_requests.created_at')}
                            </TableHeaderColumn>
                            <TableHeaderColumn
                                columnTitle={true}
                                hidden={integrationId != null}
                                width="140"
                                dataField="bookingIntegrationUrl"
                                dataSort={true}>
                                Integration
                            </TableHeaderColumn>
                            <TableHeaderColumn
                                columnTitle={true}
                                width="60"
                                dataField="bookingIntegrationCountry"
                                dataSort={true}
                                hidden={integrationId != null}>
                                Land
                            </TableHeaderColumn>
                            <TableHeaderColumn
                                width="160"
                                dataFormat={this.emailFormatter}
                                dataField="email"
                                dataSort={true}>
                                {t('search_requests.email')}
                            </TableHeaderColumn>
                            <TableHeaderColumn
                                columnTitle={true}
                                width="40"
                                dataField="pax"
                                dataAlign="center"
                                dataSort={true}>
                                {t('search_requests.pax')}
                            </TableHeaderColumn>
                            <TableHeaderColumn columnTitle={true} width="120" dataField="fromTime" dataSort={true}>
                                {t('search_requests.from.time')}
                            </TableHeaderColumn>
                            <TableHeaderColumn columnTitle={true} width="120" dataField="fromLocation" dataSort={true}>
                                {t('search_requests.from.location')}
                            </TableHeaderColumn>
                            <TableHeaderColumn columnTitle={true} width="120" dataField="toLocation" dataSort={true}>
                                {t('search_requests.to.location')}
                            </TableHeaderColumn>
                            <TableHeaderColumn columnTitle={true} width="120" dataField="toTime" dataSort={true}>
                                {t('search_requests.to.time')}
                            </TableHeaderColumn>
                            <TableHeaderColumn
                                columnTitle={true}
                                width="40"
                                dataField="intermediateCount"
                                dataSort={true}>
                                {t('search_requests.intermediateCount')}
                            </TableHeaderColumn>
                            <TableHeaderColumn
                                columnTitle={true}
                                width="40"
                                dataField="intermediateBreakSumInMinutes"
                                dataSort={true}>
                                {t('search_requests.intermediateBreakSum')}
                            </TableHeaderColumn>
                            <TableHeaderColumn
                                columnTitle={true}
                                dataField="distance"
                                width="80"
                                dataAlign="right"
                                dataFormat={this.distanceFormatter}
                                dataSort={true}>
                                {t('search_requests.distance')}
                            </TableHeaderColumn>
                            <TableHeaderColumn
                                columnTitle={true}
                                dataField="results"
                                width="60"
                                dataAlign="right"
                                dataSort={true}>
                                {t('search_requests.buses')}
                            </TableHeaderColumn>
                            <TableHeaderColumn
                                columnTitle={true}
                                dataField="cheapestPrice"
                                width="100"
                                dataAlign="right"
                                dataFormat={priceFormatter}
                                csvFormat={priceFormatter}
                                dataSort={true}>
                                {t('search_requests.min_price')}
                            </TableHeaderColumn>
                            <TableHeaderColumn
                                dataField="bookingToken"
                                width="60"
                                dataAlign="center"
                                dataFormat={(cell: any) => validFormatter(t, cell != null)}
                                dataSort={true}>
                                {t('search_requests.booked')}
                            </TableHeaderColumn>
                            <TableHeaderColumn
                                dataField="actions"
                                width="60"
                                dataFormat={this.tableActionsFormatter}
                                export={false}>
                                {t('common_phrases.actions')}
                            </TableHeaderColumn>
                        </BootstrapTable>
                    </BootstrapTableErrorBoundary>
                </div>
            </div>
        );
    }

    private fetchSearchRequests = (integrationId?: number) => {
        this.setState({ isLoading: true, tableData: [] });
        const filter = this.createActiveFilterForQuery();
        this.props.search(Entities.SEARCH_BUSES_REQUEST, `search-admin?${filter}`, 0, undefined, true, () => {});
    };

    private createActiveFilterForQuery() {
        const { selectedArea } = this.state;
        const queryParams = [];
        if (this.state.fromDate && this.state.toDate) {
            queryParams.push(`fromDate=${moment(this.state.fromDate).format('YYYY-MM-DD')}`);
            queryParams.push(`toDate=${moment(this.state.toDate).format('YYYY-MM-DD')}`);
        }
        if (selectedArea.lat && selectedArea.lng) {
            queryParams.push(`lat=${selectedArea.lat}`);
            queryParams.push(`lng=${selectedArea.lng}`);
        }
        if (this.state.includeBookingIntegrationAllCompanies)
            queryParams.push(`allCompanies=${this.state.includeBookingIntegrationAllCompanies}`);

        queryParams.push(`range=${this.state.range}`);

        return queryParams.join('&');
    }

    private createCustomToolBar = (props: ToolBarProps) => {
        const { t } = this.props;
        const { isFetching } = this.props.requests;

        return (
            <div className="col-md-12">
                <div style={{ display: 'flex', flexDirection: 'column', width: '250px' }} className="voffset40">
                    <Toggle
                        label={t('search_requests.show_only_bookings')}
                        toggled={this.state.showOnlyBookings}
                        disabled={this.state.isLoading}
                        onToggle={(event, isInputChecked) => {
                            this.setState({ showOnlyBookings: isInputChecked });
                        }}
                    />
                    <Toggle
                        label={t('search_requests.show_sales_integrations')}
                        toggled={this.state.includeBookingIntegrationAllCompanies}
                        disabled={this.state.isLoading}
                        onToggle={(event, isInputChecked) => {
                            this.setState({ includeBookingIntegrationAllCompanies: isInputChecked });
                        }}
                    />
                </div>
                <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
                    <div style={{ display: 'flex', gap: 10 }}>
                        <DatePicker
                            value={this.state.fromDate}
                            container="inline"
                            disabled={isFetching || this.state.isLoading}
                            formatDate={date => moment(date).format('DD.MM.YYYY')}
                            floatingLabelText={t('search_requests.from.title')}
                            onChange={(_event: any, value: Date) => this.setState({ fromDate: value })}
                            maxDate={this.state.toDate}
                            autoOk={true}
                            textFieldStyle={{ width: 130 }}
                        />
                        <DatePicker
                            value={this.state.toDate}
                            container="inline"
                            disabled={isFetching || this.state.isLoading}
                            formatDate={date => moment(date).format('DD.MM.YYYY')}
                            floatingLabelText={t('search_requests.to.title')}
                            onChange={(_event: any, value: Date) => this.setState({ toDate: value })}
                            minDate={this.state.fromDate}
                            autoOk={true}
                            textFieldStyle={{ width: 130 }}
                        />
                    </div>

                    <div style={{ display: 'flex', gap: 10, alignItems: 'flex-end' }}>
                        <div>
                            <AutoComplete
                                dataSource={this.state.geoCodedDataSource}
                                floatingLabelText={t('search_requests.area')}
                                disabled={this.state.isLoading}
                                filter={() => true}
                                onUpdateInput={value => {
                                    if (value.length === 0)
                                        this.setState({
                                            selectedArea: {
                                                lat: undefined,
                                                lng: undefined,
                                                address: undefined,
                                            },
                                        });
                                    this.getGeoCodedResults(value);
                                }}
                                onNewRequest={value => {
                                    this.setGeocodedFilter(value);
                                }}
                            />
                        </div>
                        <div>
                            <TextField
                                defaultValue={this.state.range}
                                type="number"
                                style={{ width: '75px' }}
                                floatingLabelText={t('search_requests.range')}
                                disabled={this.state.isLoading}
                                onChange={(event, value: any) => {
                                    this.setState({ range: parseInt(value, 10) });
                                }}
                            />
                        </div>
                        <div>
                            <button
                                className="btn"
                                style={{ height: '34px' }}
                                disabled={this.state.isLoading}
                                onClick={() => {
                                    this.fetchSearchRequests();
                                }}>
                                {this.state.isLoading
                                    ? t('common_phrases.loading')
                                    : t('search_requests.load_bookings')}
                            </button>
                        </div>
                    </div>

                    <div style={{ display: 'flex', justifyContent: 'flex-end', flexGrow: 1 }}>
                        {this.props.integrationId && (
                            <div style={{ height: 34, marginTop: 'auto' }}>
                                <RaisedButton
                                    style={{ height: 34 }}
                                    label={t('search_requests.calculate_costly_requests')}
                                    primary={true}
                                    labelColor="#ffffff"
                                    disabled={this.state.isLoading}
                                    onClick={() => {
                                        asyncRequest(
                                            `${TOMCAT_URL}api/booking-integrations/costlyRequests?integrationId=${
                                                this.props.integrationId
                                            }&fromDate=${moment(this.state.fromDate).format('YYYY-MM-DD')}&toDate=${moment(this.state.toDate).format('YYYY-MM-DD')}`,
                                        )
                                            .then(result =>
                                                this.props.addNotification(
                                                    t('search_requests.calculate_costly_requests'),
                                                    JSON.stringify(result['json']['costlyRequests']),
                                                    'success',
                                                    'tr',
                                                ),
                                            )
                                            .catch(error =>
                                                this.props.addErrorNotification({
                                                    code: error.status,
                                                    message: error.statusText,
                                                }),
                                            );
                                    }}
                                />
                            </div>
                        )}
                        <div style={{ width: 100, marginRight: 60, marginTop: 'auto' }}>
                            {props.components.exportCSVBtn}
                        </div>
                        <div style={{ width: 400, marginRight: 6, marginTop: 'auto' }}>
                            {props.components.searchPanel}
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    private renderDrawer = () => {
        return (
            <Drawer
                openSecondary={true}
                docked={false}
                width={500}
                onRequestChange={this.handleCloseDrawer}
                open={this.state.drawerOpen}>
                {this.renderRequestDetails()}
            </Drawer>
        );
    };

    private renderStats(requestsCount: number, requestBookings: number) {
        const { t } = this.props;
        return (
            <div className="col-md-3">
                {t('search_requests.total')}: {requestsCount} - {t('search_requests.booking')}: {requestBookings}
            </div>
        );
    }

    private setGeocodedFilter(place: { value: string; text: string }) {
        this.state.geoCoder.geocode({ placeId: place.value }, (res: any) => {
            if (res)
                this.setState({
                    selectedArea: {
                        lat: res[0].geometry.location.lat(),
                        lng: res[0].geometry.location.lng(),
                        address: res[0].geometry.location.address,
                    },
                });
        });
    }

    private renderRequestDetails = () => {
        const { t } = this.props;
        const row = this.state.selectedRow;
        if (!row || !this.state.drawerOpen) return null;

        return (
            <div>
                <div className="calculations-details-header">
                    <h5>{t('search_requests.details')}</h5>
                </div>
                <table className="table table-striped">
                    <thead>
                        <tr>
                            <th>{t('task_details.route')}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td className="col-md-9">
                                <p>
                                    {moment(row.entity.arrivalDateTime).format()} {row.entity.fromLocation}
                                    {moment(row.entity.toTime).format()} {row.entity.toLocation}
                                </p>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        );
    };

    private onRowClick = (row: TableDataRow) => {
        this.tableHelper.setSelectedRow(row.id);
        this.setState({
            selectedRow: row,
        });
    };

    private handleCloseDrawer = () => {
        this.setState({
            drawerOpen: false,
        });
    };

    private distanceFormatter = (distance: number) => {
        const distanceInKM = (distance / 1000).toFixed(0);
        return <span title={distanceInKM}>{`${distanceInKM} km`}</span>;
    };

    private emailFormatter = (email?: string) => {
        const { t } = this.props;
        if (!email || email.length === 0) return '';
        return (
            <div title={email}>
                <button
                    type="button"
                    className="btn btn-xs transparent"
                    onClick={() => {
                        this.handleCloseDrawer();
                        copyToClipboard(t, email, this.props.addNotification);
                    }}>
                    <span className="fa fa-clone text-info" title={t('common_phrases.copy')} />
                </button>
                {email}
            </div>
        );
    };

    private getGeoCodedResults(value: string) {
        if (value && value.length > 0) {
            const autoCompletionRequest = {
                input: value,
            };

            this.state.autoCompleteService.getPlacePredictions(autoCompletionRequest, (res: any, status: any) => {
                let suggestions = [];
                if (status === 'OK' && res && res.length > 0) {
                    suggestions = res.map((suggestion: { description: any; place_id: any }) => {
                        return {
                            text: suggestion.description,
                            value: suggestion.place_id,
                        };
                    });
                }

                this.setState({ geoCodedDataSource: suggestions });
            });
        } else if (this.state.geoCodedDataSource.length > 0) this.setState({ geoCodedDataSource: [] });
    }

    private tableActionsFormatter = (_cell: any, request: TableDataRow) => {
        const { t } = this.props;
        return (
            <div>
                <button
                    type="button"
                    className="btn btn-xs transparent"
                    title={t('user_functionality.open_in_route_planner')}
                    onClick={() => {
                        asyncRequest(`${TOMCAT_URL}api/${Entities.SEARCH_BUSES_REQUEST.repository}/${request.id}/link`)
                            .then(response => {
                                const json = response.json;
                                if (json && json.url) {
                                    const win = window.open(json.url, '_blank');
                                    if (win != null) win.focus();
                                }
                            })
                            .catch(error => console.error('Error creating Link', error));
                    }}>
                    <span className="glyphicon glyphicon-new-window text-info" />
                </button>
                <button
                    type="button"
                    className="btn btn-xs transparent"
                    title={t('search_requests.display_details')}
                    onClick={() => {
                        this.setState({
                            drawerOpen: !this.state.drawerOpen,
                        });
                    }}>
                    <span className="fa fa-info-circle text-info" />
                </button>
            </div>
        );
    };
}

const mapStateToProps = (state: StoreState) => {
    return {
        requests: getEntities(state, Entities.SEARCH_BUSES_REQUEST),
    };
};

export default connect<any, any, any>(mapStateToProps, {
    push,
    search,
    addNotification,
    addErrorNotification,
})(composeModalActions(SearchRequestsAdminTable));
